import { keyCode } from '@bingads-webui/keycode';

function replaceAtom(atom, oldKey, newKey) {
  if (oldKey in atom) {
    const newAtom = {
      ...atom,
      [newKey]: atom[oldKey],
    };
    delete newAtom[oldKey];

    return newAtom;
  }
  return atom;
}

export function replaceKeyOfFilterEntity(filterEntity, oldKey, newKey) {
  let finalQuery = { ...filterEntity.query };
  if (oldKey in finalQuery) {
    finalQuery = replaceAtom(finalQuery, oldKey, newKey);
  } else if ('$and' in finalQuery) {
    finalQuery.$and.forEach((value, index, array) => {
      // eslint-disable-next-line no-param-reassign
      array[index] = replaceAtom(value, oldKey, newKey);
    });
  }
  // eslint-disable-next-line no-param-reassign
  filterEntity.query = finalQuery;
  return filterEntity;
}

export const filterEnterKeyDown = eventHandler => (event, ...args) => {
  if (event.keyCode === keyCode.Enter) {
    eventHandler(event, ...args);
  }
};
